import * as React from 'react'
import { UserService } from './userService'

export const UserServiceContext = React.createContext(null as any as UserService)
